/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Step_RemoveInputs */

const en_editor_step_remove = /** @type {(inputs: Editor_Step_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove step`)
};

const de_editor_step_remove = /** @type {(inputs: Editor_Step_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt entfernen`)
};

/**
* | output |
* | --- |
* | "Remove step" |
*
* @param {Editor_Step_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_remove = /** @type {((inputs?: Editor_Step_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_remove(inputs)
	return en_editor_step_remove(inputs)
});